/**
 * typeLayoutPortal do portal do aluno/colaborador.
 * 0 = dark, 1 = clean. O valor 2 era o dark antigo do formulário.
 */
export function isPortalLayoutDark(value) {
    if (value === null || value === undefined || value === '') return null;
    const theme = Number(value);
    if (Number.isNaN(theme)) return null;
    if (theme === 0 || theme === 2) return true;
    if (theme === 1) return false;
    return null;
}

export function normalizePortalLayoutTheme(value) {
    const dark = isPortalLayoutDark(value);
    if (dark === null) return value ?? null;
    return dark ? 0 : 1;
}
